import {Stack, Typography} from "@mui/material";
import React from "react";
import {ExpenseModel, formatCurrency} from "../../firebase/index.js";
import {expense_green_600, expense_red_600} from "../../reusables/js/APXTheme.js";


interface ExpenseRowProps {
	  item: ExpenseModel;
}


export default function ExpenseRow({item}: ExpenseRowProps) {
	  const expense: ExpenseModel = item;
	  return (
				 <Stack direction="row" spacing={2} justifyContent="space-evenly" alignItems="center" color={"#d9d9d9"}>
						<Typography sx={{flex: 1, textAlign: "center", fontSize: "10px"}}>{new Date(expense.paidOn).toLocaleDateString()}</Typography>
						<Typography sx={{flex: 1, textAlign: "center", fontSize: "10px"}}>{expense.paidByWhom}</Typography>
						<Typography sx={{flex: 1, textAlign: "end", fontSize: "10px", color: expense.isReimbursement ? expense_green_600 : expense_red_600}}>{formatCurrency(expense.paidHowMuch)}</Typography>
						<Typography sx={{flex: 1, textAlign: "start", fontSize: "10px", color: expense.isReimbursement ? expense_green_600 : expense_red_600}}>{expense.paidForWhat}</Typography>
				 </Stack>
	  );
}